import type { IconSvgObject } from './types';

const CheckLineIcon: IconSvgObject = [
  ["path", { d: "M5 10.9999L9.00004 15L19 5.00008", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 19H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CheckLineIcon;
